import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'daysFromNow'
})
export class DaysFromNowPipe implements PipeTransform {
    transform(date?: Date | string | null): string {
        if (date == null) {
            return null;
        }

        const targetDate = new Date(date);
        const now = new Date();

        const targetMidnight = Date.UTC(targetDate.getFullYear(), targetDate.getMonth(), targetDate.getDate());
        const nowMidnight = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());

        const days = Math.round((targetMidnight - nowMidnight) / (1000 * 60 * 60 * 24));

        if (days === 0) return 'Vandaag';

        const suffix = Math.abs(days) === 1 ? 'dag' : 'dagen';
        const ago = days < 0 ? ' geleden' : '';

        return `${Math.abs(days)} ${suffix}${ago}`;
    }
}
